<script setup>
defineProps({
  isRequired: {
    type: Boolean,
    default: false,
  },
  label: String,
  shouldWrapWithLabel: { default: () => true, type: Boolean },
});
</script>

<template>
  <div>
    <label v-if="shouldWrapWithLabel" :class="$style.label">
      <span :class="$style.labelContent">
        {{ label }} <span v-if="isRequired" :class="$style.required">*</span>
      </span>
      <slot />
    </label>
    <div v-else :class="$style.label">
      {{ label }}
      <span v-if="isRequired" :class="$style.required">*</span>
      <slot />
    </div>
  </div>
</template>

<style module>

:root {
  --label-font-weight: normal;
  --label-font-size: var(--font-size-md);
}

.required {
  color: var(--secondary-color);
}

.labelContent {
  font-weight: var(--label-font-weight);
  font-size: var(--label-font-size);
}

.label {
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-bottom: 0;
}
</style>
